import type { GuestDraft } from '~publish/helpers/guestDrafts'

const GUEST_UNDATED_DRAFT_DRAG_SOURCE = 'publicCalendarUndatedDrafts'
const LABEL_MAX_LENGTH = 60

export type GuestUndatedDraftDragData = {
  type: 'contentItem'
  source: typeof GUEST_UNDATED_DRAFT_DRAG_SOURCE
  draftId: string
  label: string
}

function labelSnippet(text: string): string {
  const trimmed = text.trim()
  return trimmed.length > LABEL_MAX_LENGTH
    ? `${trimmed.slice(0, LABEL_MAX_LENGTH)}…`
    : trimmed
}

export function getGuestUndatedDraftDragLabel(draft: GuestDraft): string {
  return `Drag undated draft "${labelSnippet(draft.text)}" to schedule`
}

export function getGuestUndatedDraftDragData(
  draft: GuestDraft,
): GuestUndatedDraftDragData {
  return {
    type: 'contentItem',
    source: GUEST_UNDATED_DRAFT_DRAG_SOURCE,
    draftId: draft.id,
    label: `undated draft "${labelSnippet(draft.text)}"`,
  }
}

export function isGuestUndatedDraftDragData(
  data: unknown,
): data is GuestUndatedDraftDragData {
  return (
    typeof data === 'object' &&
    data !== null &&
    'source' in data &&
    data.source === GUEST_UNDATED_DRAFT_DRAG_SOURCE &&
    'draftId' in data &&
    typeof data.draftId === 'string'
  )
}
